module.exports = __webpack_public_path__ + "img/bg2-img3.6e196a70.png";